import { render, staticRenderFns } from "./accountTransfer.vue?vue&type=template&id=b09711f4&scoped=true"
import script from "./accountTransfer.vue?vue&type=script&lang=js"
export * from "./accountTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09711f4",
  null
  
)

export default component.exports